import {Flyout_LogoContainer_FlyoutSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/navigation_bar.types';
import {mediaDesktopAndUp} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import {styled} from '@linaria/react';
import {LogoSection} from './LogoSection';

export const LogoContainer: FC<{
  dataTestId: string;
  sections: Flyout_LogoContainer_FlyoutSection[];
}> = ({sections, dataTestId}) => {
  const isCondensedView = sections.length >= 3; // => usually in case of brand flyouts

  return (
    <Wrapper data-testid={dataTestId}>
      {sections.map((section, index) => (
        <LogoSection
          key={`logo_container_section_${index}`}
          dataTestId={`logoContainerSection_${index}`}
          section={section}
          isCondensedView={isCondensedView}
        />
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media ${mediaDesktopAndUp} {
    flex-direction: row;
    justify-content: space-around;
  }
`;
